import { validUUID } from '$lib/functions/helpers'

export function match(value) {
	return validUUID(value)
}
